import { useContext } from 'react'

import EndOfArticleContext from '@contexts/endOfArticleContext'

const useIsEndOfArticle = (): boolean => !!useContext(EndOfArticleContext)

export default useIsEndOfArticle
